import { config, handleResponse } from '../../_helpers';

export const containerVanService = {
    load,
    loadContainer,
    getContainer,
    createContainer,
    updateContainer,
    updateContainerStatus,
    deleteContainer,
    searchCVCTS,
    updateCvIsUsed,
    getAllBookingContainer,
    searchCVHustling,
};

function load(skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/ContainerVans/load?skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/ContainerVans/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function loadContainer(skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/ContainerVans/loadCVCTS?skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/ContainerVans/loadCVCTS?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getContainer(code) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ContainerVans/getContainer/${code}`, requestOptions).then(handleResponse);
}
function createContainer(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ContainerVans/create`, requestOptions).then(handleResponse);
}
function updateContainer(payload, code) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ContainerVans/update/${code}`, requestOptions).then(handleResponse);
}
function updateContainerStatus(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ContainerVans/updateStatus`, requestOptions).then(handleResponse);
}
function deleteContainer(code) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(code),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ContainerVans/delete`, requestOptions).then(handleResponse);
}
function searchCVCTS(search) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ContainerVans/searchCVCTS?search=${search}`, requestOptions).then(handleResponse);
}
function searchCVHustling(search) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ContainerVans/searchCVHustling?search=${search}`, requestOptions).then(handleResponse);
}
function updateCvIsUsed(payload, action) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ContainerVans/updateCvIsUsed?isUsed=${action}`, requestOptions).then(handleResponse);
}
function getAllBookingContainer(search) {
    const requestOptions = {
        method: 'GET'
    };
    if(search){
        return fetch(`${config.apiUrl}/ContainerVans/getAllBookingContainer?search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/ContainerVans/getAllBookingContainer`, requestOptions).then(handleResponse);
    }
}